import {
  IRequirementResponse,
  RequirementExpirationStatus
} from "@wingspanhq/payments/dist/interfaces";

export const selectorIsRequirementExpiringSoon = (
  requirement: IRequirementResponse
) => {
  return requirement.expirationStatus === RequirementExpirationStatus.Expiring;
};
